import theme from "theme";

const { default: styled } = require("@emotion/styled");

const Container = styled.div`
  position: relative;
`;

const CardContainerStyle = styled.div`
  margin: auto;
  padding: 16px;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 5px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 5px;
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333333;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 50%;
  padding: 0px 15px 0px 15px;
  margin: 0px 0px 15px 0px;
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.3;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;

  @media (max-width: 600px) {
    margin-bottom: 5px;
  }
`;

const Children = styled.div`
  flex: 1.3;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

const LoaderContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  background: rgba(255, 255, 255, 0.65);
  pointer-events: all;
`;

const ButtonContainer = styled.div`
  gap: 20px;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    margin-top: 30px;
  }
`;

const SC = {
  Container,
  CardContainerStyle,
  HeaderStyle,
  HeaderContainer,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  LoaderContainer,
  ButtonContainer,
};

export default SC;
